var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-head headroom header",class:{'headroom--unpinned': _vm.scrolled , 'header-scrolled' : _vm.scrolledTiny},on:{"scroll":_vm.handleScroll}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }